module.exports = __webpack_public_path__ + "static/media/hot-system-avatar-square-opaque.8b4fc045.png";